import { lazy, useEffect, useState } from 'react'
import { useRoutes, Navigate, useLocation, useNavigate } from 'react-router-dom'
import { useCatalogo } from "@hooks/useCatalogo"
import BlankLayout from '@layouts/BlankLayout'
import { useLayout } from '@hooks/useLayout'
import { getUserData, getHomeRouteForLoggedInUser } from '../utility/Utils'
import { getRoutes } from './routes'

const Error = lazy(() => import('../views/pages/misc/Error'))
const Login = lazy(() => import('../views/pages/authentication/Login'))
const NotAuthorized = lazy(() => import('../views/pages/NotAuthorized'))

const Router = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const [primeraVez, setprimeraVez] = useState(true)
  const [validarRol, setValidarRol] = useState(true)
  const user = getUserData()

  const { layout } = useLayout()

  const allRoutes = getRoutes(layout)

  const getHomeRoute = () => {
    const user = getUserData()
    if (user) {
      return getHomeRouteForLoggedInUser(user.rol ? user.rol : '')
    } else {
      return '/login'
    }
  }

  const routes = useRoutes([
    {
      path: '/',
      index: true,
      element: <Navigate replace to={getHomeRoute()} />
    },
    {
      path: '/login',
      element: <BlankLayout />,
      children: [{ path: '/login', element: <Login /> }],
      meta: {
        validPermission : false
      }
    },
    {
      path: '/auth/not-auth',
      element: <BlankLayout />,
      children: [{ path: '/auth/not-auth', element: <NotAuthorized /> }],
      meta: {
        validPermission : false
      }
    },
    {
      path: '*',
      element: <BlankLayout />,
      children: [{ path: '*', element: <Error /> }]
    },
    ...allRoutes
  ])

  useEffect(() => {
    // Agregar las rutas que se necesitan sean publicas
    if (
      '/auth/not-auth'   != location.pathname &&
      // '/register'        != location.pathname &&
      '/forgot-password' != location.pathname &&
      '/eventos/scann'   != location.pathname &&
      '/new'             != location.pathname &&
      '/home'            != location.pathname
    ) {
      allRoutes.forEach((route) => {
        route.children.forEach((child) => {
          if (child.path === location.pathname) {
            const validar = child.meta?.validPermission ?? true
            if (validar) {
              if (user != null) {
                setValidarPermiso(true)
              } else {
                navigate('/login', { replace: true })
              }
            }
          }
        })
      })
    }
  }, [location.pathname])
  const { administrar } = useCatalogo({ seleccion: "permisos" })
  const [validarPermiso, setValidarPermiso] = useState(false)
  useEffect(() => {
    if (validarPermiso) {
      cargar()
    }
  }, [validarPermiso])
  function cargar () {
    administrar({
      accion  : 6,
      path    : location.pathname,
      usuario : user
    }, (response) => { 
      if (!response.data.data.permiso) {
        redirect()
      }
      setValidarPermiso(false)
    }) 
  }
  function redirect(params) {
    navigate('/auth/not-auth', { replace: true })
  }
  return routes
}
export default Router
